import { useDispatch } from 'react-redux'
import { TabPane } from 'reactstrap'
import { H4, Image, P } from '../../../../../AbstractElements'
import { organizationList } from '../../../../../Data/Application/Contacts/Contacts'
import { setHistory } from '../../../../../ReduxToolkit/Reducers/ContactSlice'
import { dynamicImage } from '../../../../../Service'
import { Delete, Edit, EmailAddress, Gender, General, History, Href, Name, Personal, Print } from '../../../../../utils/Constant'

const TabOrganization = () => {
  const dispatch = useDispatch();
  return (
    <>
      {organizationList.map((item, i) =>
        <TabPane tabId={item.activeTab} key={i}>
          <div className="profile-mail">
            <div className="d-flex">
              <Image className= 'p-0 img-100 img-fluid m-r-20 rounded-circle update_img_5' src= {dynamicImage(`${item.image}`)} alt='images'  />
              <div className='flex-grow-1 mt-0'>
                <H4>
                  <span className="first_name_5">{item.name}</span>
                </H4> 

                <P className='email_add_5' >{item.email}</P>
                <ul>
                  <li><a href={Href}>{Edit}</a></li>
                  <li><a href={Href}>{Delete}</a></li>
                  <li><a href={Href} onClick={() => dispatch(setHistory())}>{History}</a></li>
                  <li><a href={Href}>{Print}</a></li>
                </ul>
              </div>
            </div>
            <div className="email-general">
              <H4>{General}</H4>
              <P>{EmailAddress}: <span className="font-primary email_add_5">{item.email}</span></P>
              <div className="gender">
                <H4>{Personal}</H4>
                <ul>
                <li>{Name}<span className="font-primary first_name_0">{item.name}</span></li>
                <li>{Gender} <span className="font-primary mobile_num_0">{item.gender}</span></li>
                <li>{EmailAddress}<span className="font-primary email_add_0">{item.email}</span></li>
              </ul>
              </div>
            </div>
          </div>
        </TabPane>
      )}
    </>
  )
}

export default TabOrganization